import { Box } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { useRef } from 'react';

import { Button } from 'evee-ui-common/components/base';
import DefaultDialog from 'widgets/layout/DefaultDialog';

import FullscreenLocationInput from '../FullscreenLocationInput';

import styles from './styles';

const FullscreenLocationSearch = ({ open, location, classes, onLocationChange, onClose }) => {
  const inputContainerRef = useRef(null);

  // Focus the location input once the dialog's enter transition has finished.
  // `onEntered` fires after the transition completes, so the DOM is stable and
  // the dialog's FocusTrap won't swallow the focus — no setTimeout/rAF needed.
  const handleEntered = () => {
    inputContainerRef.current?.querySelector('input')?.focus();
  };

  return (
    <DefaultDialog
      fullScreen
      decorateBackground
      open={open}
      renderActions={() => (
        <Button fullWidth text="Close" onClick={onClose} />
      )}
      classes={{ fullscreenContentRoot: classes.dialogContent }}
      onEntered={handleEntered}
      onClose={onClose}
    >
      <Box ref={inputContainerRef}>
        <FullscreenLocationInput
          value={location}
          placeholder="City, airport or suburb"
          onChange={(value) => {
            onLocationChange(value);
            onClose();
          }}
        />
      </Box>
    </DefaultDialog>
  );
};

FullscreenLocationSearch.propTypes = {
  open: PropTypes.bool,
  location: PropTypes.object,
  classes: PropTypes.shape({
    dialogContent: PropTypes.string,
  }).isRequired,
  onLocationChange: PropTypes.func,
  onClose: PropTypes.func,
};

FullscreenLocationSearch.defaultProps = {
  open: false,
  location: {},
  onLocationChange: () => {},
  onClose: () => {},
};

export default withStyles(styles)(FullscreenLocationSearch);